import placeholder from "../img/componentes/1.webp";

// MANUALES
import soporteMuroSencillo from "../img/componentes/manuales/soporte-muro-sencillo.webp";
import soporteMuroDoble from "../img/componentes/manuales/soporte-muro-doble.webp";
import unionRielMuro from "../img/componentes/manuales/union-riel-muro.webp";
import bastonFv152 from "../img/componentes/manuales/baston-fv-152.webp";
import bastonFv182 from "../img/componentes/manuales/baston-fv-182.webp";
import carroMaestroPfDer from "../img/componentes/manuales/carro-maestro-pf-der.webp";
import carroMaestroPfIzq from "../img/componentes/manuales/carro-maestro-pf-izq.webp";
import carroMaestroRfDer from "../img/componentes/manuales/carro-maestro-rf-der.webp";
import carroMaestroRfIzq from "../img/componentes/manuales/carro-maestro-rf-izq.webp";
import taponFinalPf from "../img/componentes/manuales/tapon-final-pf.webp";
import taponFinalRf from "../img/componentes/manuales/tapon-final-rf.webp";
import correderaPf from "../img/componentes/manuales/corredera-pf.webp";
import correderaRf60 from "../img/componentes/manuales/corredera-rf-60.webp";
import correderaRf100 from "../img/componentes/manuales/corredera-rf-100.webp";
import ganchoAcero138 from "../img/componentes/manuales/gancho-acero-138.webp";
import cintaBrochesRf11cm from "../img/componentes/manuales/cinta-broches-rf-11cm.webp";
import cintaBrochesRf16cm from "../img/componentes/manuales/cinta-broches-rf-16cm.webp";
import cintaBrochesRf21cm from "../img/componentes/manuales/cinta-broches-rf-21cm.webp";
import ganchoTwistAroFlechaRf from "../img/componentes/manuales/gancho-twist-aro-flecha-rf.webp";
import cintaPlisadoraRf from "../img/componentes/manuales/cinta-plisadora-rf.webp";
import rielTechoManual58 from "../img/componentes/manuales/riel-techo-manual-58.webp";
import rielMuroManual58 from "../img/componentes/manuales/riel-muro-manual-58.webp";

// MOTORIZADOS
import tapaSistemaEngrane from "../img/componentes/motorizados/tapa-sistema-engrane.webp";
import sistemaEngraneWifi from "../img/componentes/motorizados/sistema-engrane-wifi.webp";
import ganchoFinalPf from "../img/componentes/motorizados/gancho-final-pf.webp";
import ganchoFinalRf from "../img/componentes/motorizados/gancho-final-rf.webp";
import rielMotorizado580 from "../img/componentes/motorizados/riel-motorizado-580.webp";
import correderaPfMotorizado from "../img/componentes/motorizados/corredera-pf.webp";
import correderaRf from "../img/componentes/motorizados/corredera-rf.webp";
import gomaVerdeBandaDentada from "../img/componentes/motorizados/goma-verde-banda-dentada.webp";
import correaGomaSeguroBanda from "../img/componentes/motorizados/correa-goma-seguro-banda.webp";
import soporteTecho from "../img/componentes/motorizados/soporte-techo.webp";
import soporteMuro from "../img/componentes/motorizados/soporte-muro.webp";
import soporteMuroDobleMotorizado from "../img/componentes/motorizados/soporte-muro-doble.webp";
import carroMaestro1hPf from "../img/componentes/motorizados/carro-maestro-1h-pf.webp";
import carroMaestro1hRf from "../img/componentes/motorizados/carro-maestro-1h-rf.webp";
import carroMaestro2hRf from "../img/componentes/motorizados/carro-maestro-2h-rf.webp";
import topeMecanismoSinSujecion from "../img/componentes/motorizados/tope-mecanismo-sin-sujecion.webp";
import topeMecanismoConSujecion from "../img/componentes/motorizados/tope-mecanismo-con-sujecion.webp";
import motorBateriaRf from "../img/componentes/motorizados/motor-bateria-rf.webp";
import motorWifi from "../img/componentes/motorizados/motor-wifi.webp";
import controlMonocanal from "../img/componentes/motorizados/control-monocanal.webp";
import controlMulticanal15 from "../img/componentes/motorizados/control-multicanal-15.webp";

export const imagenesComponentes = {

  // MANUALES
  "soporte-muro-sencillo": soporteMuroSencillo,
  "soporte-muro-doble": soporteMuroDoble,
  "union-riel-muro": unionRielMuro,
  "baston-fv-152": bastonFv152,
  "baston-fv-182": bastonFv182,
  "carro-maestro-pf-der": carroMaestroPfDer,
  "carro-maestro-pf-izq": carroMaestroPfIzq,
  "carro-maestro-rf-der": carroMaestroRfDer,
  "carro-maestro-rf-izq": carroMaestroRfIzq,
  "tapon-final-pf": taponFinalPf,
  "tapon-final-rf": taponFinalRf,
  "corredera-pf": correderaPf,
  "corredera-rf-60": correderaRf60,
  "corredera-rf-100": correderaRf100,
  "gancho-acero-138": ganchoAcero138,
  "cinta-broches-rf-11cm": cintaBrochesRf11cm,
  "cinta-broches-rf-16cm": cintaBrochesRf16cm,
  "cinta-broches-rf-21cm": cintaBrochesRf21cm,
  "gancho-twist-aro-flecha-rf": ganchoTwistAroFlechaRf,
  "cinta-plisadora-rf": cintaPlisadoraRf,
  "riel-techo-manual-58": rielTechoManual58,
  "riel-muro-manual-58": rielMuroManual58,

  // MOTORIZADOS
  "tapa-sistema-engrane": tapaSistemaEngrane,
  "sistema-engrane-wifi": sistemaEngraneWifi,
  "gancho-final-pf": ganchoFinalPf,
  "gancho-final-rf": ganchoFinalRf,
  "riel-motorizado-580": rielMotorizado580,
  "corredera-rf": correderaRf,
  "goma-verde-banda-dentada": gomaVerdeBandaDentada,
  "correa-goma-seguro-banda": correaGomaSeguroBanda,
  "soporte-techo": soporteTecho,
  "soporte-muro": soporteMuro,
  "carro-maestro-1h-pf": carroMaestro1hPf,
  "carro-maestro-1h-rf": carroMaestro1hRf,
  "carro-maestro-2h-rf": carroMaestro2hRf,
  "tope-mecanismo-sin-sujecion": topeMecanismoSinSujecion,
  "tope-mecanismo-con-sujecion": topeMecanismoConSujecion,
  "motor-bateria-rf": motorBateriaRf,
  "motor-wifi": motorWifi,
  "control-monocanal": controlMonocanal,
  "control-multicanal-15": controlMulticanal15,

  // Imagen por defecto
  placeholder
};